import { useEffect, useRef } from "react";
import { BUILD_INFO } from "../build-info";
import { SOURCE_URL } from "../links";
import { closeOnBackdrop } from "./dialog";
import { Icon, Logo } from "./Icon";

/** Help → About: what codescreen is, and which build this is. */
export function AboutDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = dialogRef.current;
    if (open && !dialog?.open) dialog?.showModal();
    if (!open && dialog?.open) dialog.close();
  }, [open]);
  const built = new Date(BUILD_INFO.builtAt * 1000);
  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: Escape closes dialogs natively; this only adds backdrop clicks for the mouse
    <dialog
      ref={dialogRef}
      className="dialog about-dialog"
      aria-label="About codescreen"
      onClick={closeOnBackdrop}
      onClose={onClose}
    >
      <div className="about">
        <Logo size={56} />
        <h2>codescreen</h2>
        <p className="about-tagline">Live coding interviews in the browser.</p>
        <ul className="about-how">
          <li>
            Peer to peer. Browsers find each other through public <strong>Nostr</strong> relays,
            then connect directly with <strong>WebRTC</strong>. Code, chat and terminals go straight
            between you, encrypted. If a direct connection fails, an <strong>iroh</strong> relay
            forwards the encrypted traffic instead.
          </li>
          <li>No codescreen server and no accounts: the site is static files.</li>
          <li>Code runs in your own browser, and only when you press Run.</li>
        </ul>
        <a className="about-source" href={SOURCE_URL} target="_blank" rel="noopener noreferrer">
          <Icon name="github" size={14} />
          github.com/fcjr/codescreen.link
        </a>
        <dl className="about-build">
          <dt>Version</dt>
          <dd>{BUILD_INFO.version}</dd>
          <dt>Build</dt>
          <dd>
            {BUILD_INFO.sha} · {built.toISOString().slice(0, 10)}
          </dd>
          <dt>License</dt>
          <dd>MIT</dd>
        </dl>
        <form method="dialog" className="dialog-actions">
          <button type="submit" className="primary">
            OK
          </button>
        </form>
      </div>
    </dialog>
  );
}
